import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFurnace2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 100,
	viewBox: "0 0 80.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 15.0 100.0 L 0.0 85.0 L 0.0 0.0 L 80.0 0.0 L 80.0 85.0 L 65.0 100.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 10.0 0.0 L 10.0 80.0 L 20.0 90.0 L 60.0 90.0 L 70.0 80.0 L 70.0 0.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgFurnace2;
